export const PRODUCT_TAX_RATE = 1.08
export const SHOPPING_BAG_TAX_RATE = 1.1
export const DELIVERY_FEE_TAX_RATE = 1.1
